import React, { useCallback, useState, SyntheticEvent, useMemo } from 'react'

import { IHIInvoiceLineActivity } from '../../../../interfaces/IHealthInsurance'
import { TdInput } from '../TableRow/style'

import { StyledList, StyledListItem } from './style'

interface IProps {
  options: IHIInvoiceLineActivity[]
  onChange: (val: SyntheticEvent) => void
  onSelect: (val: IHIInvoiceLineActivity) => void
  onBlur?: (e: SyntheticEvent) => void
  onFocus?: (e: SyntheticEvent) => void
  value: string | undefined
}

export const ActivityOptionFilter = ({
  options,
  value,
  onChange,
  onFocus,
  onBlur,
  onSelect,
}: IProps) => {
  const [isFocused, setFocused] = useState<boolean>()

  if (!options) return null
  const handleFocus = useCallback(
    (e: SyntheticEvent) => {
      setFocused(true)
      onFocus && onFocus(e)
    },
    [onFocus, setFocused],
  )

  const handleBlur = useCallback(
    (e: SyntheticEvent) => {
      setFocused(false)
      onBlur && onBlur(e)
    },
    [onBlur, setFocused],
  )

  const handleItemClick = useCallback(
    (treatmentOption: IHIInvoiceLineActivity) => {
      onSelect(treatmentOption)
    },
    [onSelect],
  )

  const filteredOptions = useMemo(
    () =>
      options.filter(option =>
        option.treatmentName.toLowerCase().includes(value?.toLowerCase()),
      ),
    [options, value],
  )

  return (
    <div>
      <TdInput
        type="text"
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={onChange}
      />
      {isFocused && (
        <StyledList>
          {filteredOptions.map(treatmentOption => (
            <StyledListItem
              key={treatmentOption.treatmentUuid}
              value={treatmentOption.treatmentName}
              onMouseDown={e => e.preventDefault()}
              onClick={() => handleItemClick(treatmentOption)}>
              {treatmentOption.treatmentName}
            </StyledListItem>
          ))}
        </StyledList>
      )}
    </div>
  )
}
